module.exports = __webpack_public_path__ + "static/media/logo.42c9c8d9.png";